/** Extract add-on ids from API SelectedDropDown list or raw ids. */
export const extractVenueConfigAddonIds = (addOns: any[] | undefined | null): number[] => {
  if (!Array.isArray(addOns) || addOns.length === 0) {
    return [];
  }
  return addOns
    .map(item => {
      if (item == null) {
        return NaN;
      }
      if (typeof item === 'object' && 'value' in item) {
        return Number(item.value);
      }
      return Number(item);
    })
    .filter(id => !Number.isNaN(id));
};
